import axios from 'axios';
import React, { useContext, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Form, Spinner } from 'react-bootstrap';
import InputGroup from 'react-bootstrap/InputGroup';
import { BsFillEyeFill, BsFillEyeSlashFill } from 'react-icons/bs';
import { Store } from '../Store';
import { toast } from '../toasts';
import { getError } from '../utils';
import '../App.css';

function VerifyUser() {
	const navigate = useNavigate();
	const params = useParams();
	const { token } = params;
	const { dispatch: ctxDispatch } = useContext(Store);

	const [password, setPassword] = useState('');
	const [confirmPassword, setConfirmPassword] = useState('');
	const [passwordType, setPasswordType] = useState('password');
	const [repeatPasswordType, setRepeatPasswordType] = useState('password');
	const [loading, setLoading] = useState(false);

	const togglePassword = () => {
		if (passwordType === 'password') {
			setPasswordType('text');
			return;
		}
		setPasswordType('password');
	};

	const toggleRepeatPassword = () => {
		if (repeatPasswordType === 'password') {
			setRepeatPasswordType('text');
			return;
		}
		setRepeatPasswordType('password');
	};

	const submitHandler = async (e) => {
		e.preventDefault();
		if (password !== confirmPassword) {
			toast.error('Revise su contraseña');
			return;
		}
		setLoading(true);
		try {
			const { data } = await axios.put(`/api/auth/verifyUser/${token}`, {
				password,
			});
			ctxDispatch({ type: 'USER_SIGNIN', payload: data });
			localStorage.setItem('userInfo', JSON.stringify(data));
			navigate('/');
			toast.success('Usuario actualizado correctamente');
		} catch (err) {
			toast.error(getError(err));
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className='auth-screen verify-user'>
			<Helmet>
				<title>Cambiar Contraseña</title>
			</Helmet>
			<div className='auth-screen__content'>
				<Form className='auth-card' onSubmit={submitHandler}>
					<h2 className='auth-card__title'>Cambia tu contraseña</h2>

					<Form.Group className='auth-field' controlId='verify-password'>
						<Form.Label>Contraseña</Form.Label>
						<InputGroup className='auth-password-group'>
							<Form.Control
								className='auth-input'
								type={passwordType}
								placeholder='••••••••'
								required
								onChange={(e) => setPassword(e.target.value)}
							/>
							<Button
								type='button'
								variant='link'
								className='auth-password-toggle'
								aria-label={passwordType === 'password' ? 'Mostrar contraseña' : 'Ocultar contraseña'}
								onClick={togglePassword}
							>
								{passwordType === 'password' ? <BsFillEyeSlashFill /> : <BsFillEyeFill />}
							</Button>
						</InputGroup>
					</Form.Group>

					<Form.Group className='auth-field' controlId='verify-confirm-password'>
						<Form.Label>Repetir contraseña</Form.Label>
						<InputGroup className='auth-password-group'>
							<Form.Control
								className='auth-input'
								type={repeatPasswordType}
								placeholder='••••••••'
								required
								onChange={(e) => setConfirmPassword(e.target.value)}
							/>
							<Button
								type='button'
								variant='link'
								className='auth-password-toggle'
								aria-label={repeatPasswordType === 'password' ? 'Mostrar contraseña' : 'Ocultar contraseña'}
								onClick={toggleRepeatPassword}
							>
								{repeatPasswordType === 'password' ? <BsFillEyeSlashFill /> : <BsFillEyeFill />}
							</Button>
						</InputGroup>
					</Form.Group>

					<Button className='auth-submit' type='submit' disabled={loading}>
						{loading ? (
							<>
								<Spinner animation='border' size='sm' className='me-1' />
								Actualizando...
							</>
						) : (
							'Actualizar'
						)}
					</Button>
				</Form>
			</div>
		</div>
	);
}

export default VerifyUser;
